import React from "react";
import { FaCode, FaLock, FaTools } from "react-icons/fa";
import "../styles/Services.css";

function Services({ onServiceClick }) {
  const services = [
    {
      id: 1,
      title: "Software & Web Development",
      description:
        "Custom software solutions and modern web applications tailored to your business needs.",
      icon: FaCode,
      features: ["Custom Development", "System Integration", "Web Apps"],
    },
    {
      id: 2,
      title: "Cybersecurity",
      description:
        "Protect your digital assets with advanced security solutions.",
      icon: FaLock,
      features: ["Security Audits", "Penetration Testing", "Protection"],
    },
    {
      id: 3,
      title: "Tech Repair & Support",
      description: "Reliable technical support and repair services.",
      icon: FaTools,
      features: ["Hardware Repair", "Software Fixes", "24/7 Support"],
    },
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="section-header">
          <h2>My Services</h2>
          <p>Professional technology solutions</p>
        </div>

        <div className="services-grid">
          {services.map((service) => {
            const Icon = service.icon;

            return (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  <Icon />
                </div>

                <h3>{service.title}</h3>
                <p>{service.description}</p>

                <ul className="features-list">
                  {service.features.map((f, i) => (
                    <li key={i}>✓ {f}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Services;
